import { Classes, Spinner } from '@blueprintjs/core';
import omit from 'lodash/omit';
import * as React from 'react';
import { Dialog } from 'vet-bones/components';
import { noop } from 'vet-bones/utils';

import { TEST_IDS } from 'src/constants/testIds';
import { SignInForm } from 'src/containers/ConnectionMenu/SignInForm';
import { connectionSelector } from 'src/selectors/connection';
import { isConnectingSelector } from 'src/selectors/isConnecting';
import { connectToStardog } from 'src/store/connections/connectToStardog';
import { Connection } from 'src/store/connections/types';
import { uiSlice } from 'src/store/ui/ui.slice';
import * as copy from 'src/templates/copy';
import { icons } from 'src/templates/icons';
import { useAlertWebProtocolInconsistencies } from 'src/utils/hooks/useAlertWebProtocolInconsistencies';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

export const SignInDialog: React.VFC = () => {
  const dispatch = useReduxDispatch();
  const connection = useReduxSelector(connectionSelector);
  const isConnecting = useReduxSelector(isConnectingSelector);
  const isOpen = useReduxSelector((state) => state.ui.isSignInDialogOpen);

  useAlertWebProtocolInconsistencies();

  const handleCloseDialog = () =>
    dispatch(uiSlice.actions.closedSignInDialog());
  const handleConnect = (conn: Connection) =>
    dispatch(connectToStardog({ connection: omit(conn, 'token') }));

  return (
    <Dialog
      canEscapeKeyClose={false}
      canOutsideClickClose={false}
      className="sd-dialog-connection"
      closeIconTestId={TEST_IDS.dialog.closeIcon}
      icon={icons.connection}
      isOpen={isOpen}
      onClose={handleCloseDialog}
      title={copy.components.signInDialog.title}
    >
      <div className={Classes.DIALOG_BODY}>
        {connection ? (
          <SignInForm
            connection={connection}
            onSubmit={isConnecting ? noop : handleConnect}
          />
        ) : (
          <Spinner />
        )}
      </div>
    </Dialog>
  );
};
